import { FF_API_BASE_PATH, PROV_API_BASE_PATH, FF_API_COLLECTION_FORMATS, PROV_API_COLLECTION_FORMATS, BILL_API_BASE_PATH } from "../shared-api";

// CURSUSのGUIソースに合わせて、variablesファイルを各業務にて作成
// ただし、中身は、shared-apiからのimport
export { FF_API_BASE_PATH, PROV_API_BASE_PATH, FF_API_COLLECTION_FORMATS, PROV_API_COLLECTION_FORMATS, BILL_API_BASE_PATH }
export const BILL_API_COLLECTION_FORMATS = {
    'csv': ',',
    'tsv': '   ',
    'ssv': ' ',
    'pipes': '|'
}
